import { flushLogs, getPersistedLogs } from '../browser/persistedLogs';

const logBuffer = [];
const MAX_ENTRIES = 1000;
const VERBOSE_TRUNCATE_AT = 200;
const FLUSH_THRESHOLD = 50;
const FLUSH_INTERVAL_MS = 30000;

const pendingFlush = [];

function flush() {
  if (pendingFlush.length === 0) return;
  flushLogs([...pendingFlush]);
  pendingFlush.length = 0;
}

setInterval(flush, FLUSH_INTERVAL_MS);

// Seed in-memory buffer from persisted logs on startup
getPersistedLogs().then((persisted) => {
  if (persisted?.length) {
    logBuffer.unshift(...persisted);
    if (logBuffer.length > MAX_ENTRIES) logBuffer.splice(0, logBuffer.length - MAX_ENTRIES);
  }
});

['log', 'debug', 'error', 'warn'].forEach((level) => {
  const orig = console[level].bind(console);
  console[level] = (...args) => {
    orig(...args);
    const msg = args
      .map((a) => {
        if (a instanceof Error) return `${a.message}\n${a.stack}`;
        if (typeof a === 'object') {
          try { return JSON.stringify(a); } catch { return String(a); }
        }
        return String(a);
      })
      .join(' ');

    const entry = {
      level,
      ts: new Date().toISOString(),
      msg: msg.includes('[VERBOSE]') ? msg.slice(0, VERBOSE_TRUNCATE_AT) + '...' : msg,
    };

    logBuffer.push(entry);
    if (logBuffer.length > MAX_ENTRIES) logBuffer.shift();

    pendingFlush.push(entry);
    if (pendingFlush.length >= FLUSH_THRESHOLD) flush();
  };
});

export const getLogs = () => [...logBuffer];
export const clearLogs = () => { logBuffer.length = 0; };
